<div class="accordian fusion-accordian">
  <div class="panel-group" id="accordion-1423-1" role="tablist">
    <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
      <div class="panel-heading">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .ng-go-back-link {
              margin-bottom: 0px !important;
            }

            div.ng-go-back-link p {
              text-align: left !important;
            }

            .ng-space {
              margin-top: 40px !important;
            }
          }
        </style>
        <div class="ng-go-back-link" style="margin-bottom: -60px">
          <p style="text-align: right; cursor: pointer">
            <a (click)="goToAnnouncements()" target="_self"><strong>&lt; Torna ai Miei Annunci</strong></a>
          </p>
        </div>
        <div style="width: min-content">
          <h4 class="panel-title toggle">
            <a aria-expanded="false" aria-selected="false" aria-controls="97d3a81aaa944fa91" role="tab"
              data-toggle="collapse" data-parent="#accordion-1423-1" data-target="#97d3a81aaa944fa91"
              href="#97d3a81aaa944fa91"><span class="fusion-toggle-icon-wrapper" aria-hidden="true"><i
                  class="fa-fusion-box"></i></span><span class="fusion-toggle-heading">LEGENDA</span></a>
          </h4>
        </div>

        <div id="97d3a81aaa944fa91" class="panel-collapse collapse">
          <style>
            ol.letter,
            ol.number {
              counter-reset: list;
              margin: 10px 0 10px 0;
            }

            ol.letter>li,
            ol.number>li {
              list-style: none;
              font-size: 15px;
              color: #333333;
              font-weight: 400;
              margin-top: 10px;
            }

            ol.letter>li:before {
              counter-increment: list;
              content: counter(list, lower-alpha) ") ";
            }

            ol.number>li:before {
              content: counter(list) ") ";
              counter-increment: list;
            }

            span.column-name {
              border: 1px solid #333333;
              margin-right: 5px;
              padding: 0 2px;
              font-size: 14px;
            }
          </style>
        </div>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"></div>
    <div class="fusion-sep-clear"></div>
    <h3 style="font-family: Montserrat, Arial, Helvetica, sans-serif">
      <strong>{{ announcement.title }}</strong>
    </h3>
    <style>
      #statusContainer {
        display: flex;
        justify-content: space-between;
      }

      #condivisionLabel {
        padding: 3px 10px;
        font-size: 22px;
        color: var(--ng-app-theme-yellow-color);
      }

      @media only screen and (max-width: 910px) {
        #statusContainer {
          flex-direction: column !important;
        }

        #condivisionLabel {
          padding: 0px !important;
        }
      }
    </style>
    <div id="statusContainer">
      <div style="font-family: Montserrat, Arial, Helvetica, sans-serif">
        <strong style="
            background-color: var(--ng-app-theme-yellow-color);
            padding: 3px 10px;
            font-size: 22px;
            color: #ffffff;
          ">{{ getAnnouncementStatusDescr() }}</strong>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 40px"></div>
    <p><strong>INFORMAZIONI GENERALI</strong></p>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
    <form [formGroup]="form" id="appform">
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>

      <ul class="fusion-checklist fusion-checklist-1" style="font-size: 16px; line-height: 27.2px">
        <li class="fusion-li-item">
          <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
              class="fusion-li-icon fa-info fas" style="color: #333333"></i></span>
          <div class="fusion-li-item-content" style="margin-left: 38.4px">
            <p>TITOLO DELL'ANNUNCIO*</p>
          </div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-1 .fusion-button-text,
          .fusion-button.button-1 i {
            color: #a5a5a5;
          }

          .fusion-button.button-1 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-1:hover .fusion-button-text,
          .fusion-button.button-1:hover i,
          .fusion-button.button-1:focus .fusion-button-text,
          .fusion-button.button-1:focus i,
          .fusion-button.button-1:active .fusion-button-text,
          .fusion-button.button-1:active {
            color: #ffffff;
          }

          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-1:hover,
          .fusion-button.button-1:focus,
          .fusion-button.button-1:active {
            border-color: #ffffff;
          }

          .fusion-button.button-1 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-1 {
            background: #ffffff;
          }

          .fusion-button.button-1:hover,
          .button-1:focus,
          .fusion-button.button-1:active {
            background: #ffffff;
          }
        </style>
        <input type="text" placeholder="Titolo" formControlName="title" id="title" (click)="resetError()" required
          maxlength="150" />
        <div [ngStyle]="{
            visibility:
              form.get('title').valid || form.get('title').pristine
                ? 'hidden'
                : 'visible'
          }" class="ng-alert">
          Inserire un titolo per l'annuncio.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
      <ul class="fusion-checklist fusion-checklist-2" style="font-size: 16px; line-height: 27.2px">
        <li class="fusion-li-item">
          <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
              class="fusion-li-icon fa-align-center fas" style="color: #333333"></i></span>
          <div class="fusion-li-item-content" style="margin-left: 38.4px">
            <p>BREVE DESCRIZIONE*</p>
          </div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-2 .fusion-button-text,
          .fusion-button.button-2 i {
            color: #a5a5a5;
          }

          .fusion-button.button-2 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-2:hover .fusion-button-text,
          .fusion-button.button-2:hover i,
          .fusion-button.button-2:focus .fusion-button-text,
          .fusion-button.button-2:focus i,
          .fusion-button.button-2:active .fusion-button-text,
          .fusion-button.button-2:active {
            color: #ffffff;
          }

          .fusion-button.button-2:hover .fusion-button-icon-divider,
          .fusion-button.button-2:hover .fusion-button-icon-divider,
          .fusion-button.button-2:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-2:hover,
          .fusion-button.button-2:focus,
          .fusion-button.button-2:active {
            border-color: #ffffff;
          }

          .fusion-button.button-2 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-2 {
            background: #ffffff;
          }

          .fusion-button.button-2:hover,
          .button-2:focus,
          .fusion-button.button-2:active {
            background: #ffffff;
          }
        </style>
        <textarea type="text" placeholder="Descrizione" formControlName="description" id="description"
          (click)="resetError()" required maxlength="1500"></textarea>
        <div [ngStyle]="{
            visibility:
              form.get('description').valid ||
              form.get('description').pristine
                ? 'hidden'
                : 'visible'
          }" class="ng-alert">
          Inserire una descrizione per l'annuncio'.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>

      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-13
        fusion-one-half
        fusion-column-first
        1_2
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(48%);
        margin-right: 4%;
      ">
          <div class="fusion-column-wrapper fusion-column-wrapper-13" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-5" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-id-card-alt" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  TIPO ANNUNCIO*
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-8 .fusion-button-text,
                .fusion-button.button-8 i {
                  color: #333333;
                }

                .fusion-button.button-8 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-8:hover .fusion-button-text,
                .fusion-button.button-8:hover i,
                .fusion-button.button-8:focus .fusion-button-text,
                .fusion-button.button-8:focus i,
                .fusion-button.button-8:active .fusion-button-text,
                .fusion-button.button-8:active {
                  color: #ffffff;
                }

                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-8:hover,
                .fusion-button.button-8:focus,
                .fusion-button.button-8:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-8 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-8 {
                  background: #ffffff;
                }

                .fusion-button.button-8:hover,
                .button-8:focus,
                .fusion-button.button-8:active {
                  background: #ffffff;
                }
              </style>
              <select formControlName="announcementType" id="announcementTypeComp">
                <option [ngValue]="null"></option>
                <option [ngValue]="announcementType" *ngFor="let announcementType of announcementTypeList">
                  {{ getAnnouncementTypeDescr(announcementType) }}
                </option>
              </select>
              <div [ngStyle]="{
                  visibility: announcementTypeError === 'no_error' ? 'hidden' : 'visible'
                }" class="ng-alert">
                {{ announcementTypeError }}
              </div>

            </div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-12
            fusion-one-half
            fusion-column-last
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 48%;
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-12" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-5" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-id-card-alt" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  CATEGORIA*
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-8 .fusion-button-text,
                .fusion-button.button-8 i {
                  color: #333333;
                }

                .fusion-button.button-8 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-8:hover .fusion-button-text,
                .fusion-button.button-8:hover i,
                .fusion-button.button-8:focus .fusion-button-text,
                .fusion-button.button-8:focus i,
                .fusion-button.button-8:active .fusion-button-text,
                .fusion-button.button-8:active {
                  color: #ffffff;
                }

                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-8:hover,
                .fusion-button.button-8:focus,
                .fusion-button.button-8:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-8 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-8 {
                  background: #ffffff;
                }

                .fusion-button.button-8:hover,
                .button-8:focus,
                .fusion-button.button-8:active {
                  background: #ffffff;
                }
              </style>
              <select formControlName="categoryCode" id="category">
                <option [ngValue]="null"></option>
                <option [ngValue]="category.code" *ngFor="let category of categoryList">
                  {{ category.description }}
                </option>
              </select>
              <div [ngStyle]="{
                  visibility: categoryError === 'no_error' ? 'hidden' : 'visible'
                }" class="ng-alert">
                {{ categoryError }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-13
        fusion-one-half
        fusion-column-first
        1_2
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 25%;
        width: calc(25% - ((4% + 4%) * 0.5));
        margin-right: 4%;
      ">
          <div class="fusion-column-wrapper fusion-column-wrapper-13" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-5" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-id-card-alt" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  QUANTITA'*
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-8 .fusion-button-text,
                .fusion-button.button-8 i {
                  color: #333333;
                }

                .fusion-button.button-8 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-8:hover .fusion-button-text,
                .fusion-button.button-8:hover i,
                .fusion-button.button-8:focus .fusion-button-text,
                .fusion-button.button-8:focus i,
                .fusion-button.button-8:active .fusion-button-text,
                .fusion-button.button-8:active {
                  color: #ffffff;
                }

                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-8:hover,
                .fusion-button.button-8:focus,
                .fusion-button.button-8:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-8 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-8 {
                  background: #ffffff;
                }

                .fusion-button.button-8:hover,
                .button-8:focus,
                .fusion-button.button-8:active {
                  background: #ffffff;
                }
              </style>
              <input class="ng-app-input" type="number" formControlName="amount" oninput="this.value = 
              !!this.value && Math.abs(this.value) >= 1 ? Math.abs(this.value) : null" min="1" />

            </div>
          </div>
        </div>
        <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_4
        fusion-builder-nested-column-14
        fusion-one-fourth
        1_4
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4% + 4%) * 0.25));
        margin-right: 4%;
      ">
          <div class="fusion-column-wrapper fusion-column-wrapper-14" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-6" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-id-card-alt" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  UNITA' DI MISURA*
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-9 .fusion-button-text,
                .fusion-button.button-9 i {
                  color: #333333;
                }

                .fusion-button.button-9 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-9:hover .fusion-button-text,
                .fusion-button.button-9:hover i,
                .fusion-button.button-9:focus .fusion-button-text,
                .fusion-button.button-9:focus i,
                .fusion-button.button-9:active .fusion-button-text,
                .fusion-button.button-9:active {
                  color: #ffffff;
                }

                .fusion-button.button-9:hover .fusion-button-icon-divider,
                .fusion-button.button-9:hover .fusion-button-icon-divider,
                .fusion-button.button-9:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-9:hover,
                .fusion-button.button-9:focus,
                .fusion-button.button-9:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-9 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-9 {
                  background: #ffffff;
                }

                .fusion-button.button-9:hover,
                .button-9:focus,
                .fusion-button.button-9:active {
                  background: #ffffff;
                }
              </style>
              <select formControlName="unitOfMeasureCode" id="unitOfMeasureComp">
                <option [ngValue]="null"></option>
                <option [ngValue]="unitOfMeasure.code" *ngFor="let unitOfMeasure of unitOfMeasureList">
                  {{ unitOfMeasure.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_4
        fusion-builder-nested-column-15
        fusion-one-fourth
        fusion-column-last
        1_4
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 25%;
        width: calc(25% - ((4% + 4%) * 0.25));
      ">
          <div class="fusion-column-wrapper fusion-column-wrapper-15" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-7" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-id-card-alt" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  €/UNITA'*
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 .fusion-button-text,
                .fusion-button.button-10 i {
                  color: #333333;
                }

                .fusion-button.button-10 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-10:hover .fusion-button-text,
                .fusion-button.button-10:hover i,
                .fusion-button.button-10:focus .fusion-button-text,
                .fusion-button.button-10:focus i,
                .fusion-button.button-10:active .fusion-button-text,
                .fusion-button.button-10:active {
                  color: #ffffff;
                }

                .fusion-button.button-10:hover .fusion-button-icon-divider,
                .fusion-button.button-10:hover .fusion-button-icon-divider,
                .fusion-button.button-10:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-10:hover,
                .fusion-button.button-10:focus,
                .fusion-button.button-10:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-10 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-10 {
                  background: #ffffff;
                }

                .fusion-button.button-10:hover,
                .button-10:focus,
                .fusion-button.button-10:active {
                  background: #ffffff;
                }
              </style>
              <input class="ng-app-input" type="number" formControlName="unitPrice" 
                onchange="this.value = parseFloat(Math.abs(this.value)).toFixed(2); this.value > 0 ? this.value = this.value : this.value = null" 
                min="1" />
            </div>
          </div>
        </div>
        <div [ngStyle]="{
                  visibility: unitOfMeasureError === 'no_error' ? 'hidden' : 'visible'
                }" class="ng-alert">
          {{ unitOfMeasureError }}
        </div>
      </div>
      <div *ngIf="form.get('announcementType').value === 'RENTAL'">
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none ng-space"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
        <p><strong>PERIODO DI DISPONIBILITA'</strong></p>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-11
            fusion-one-half
            fusion-column-first
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          ">
            <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-9" style="font-size: 16px; line-height: 27.2px">
                <li class="fusion-li-item">
                  <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                      class="fusion-li-icon fa-calendar-alt fas" style="color: #333333"></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 38.4px">
                    <p>DAL*</p>
                  </div>
                </li>
              </ul>
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-8 .fusion-button-text,
                  .fusion-button.button-8 i {
                    color: #c4c4c4;
                  }

                  .fusion-button.button-8 .fusion-button-icon-divider {
                    border-color: #c4c4c4;
                  }

                  .fusion-button.button-8:hover .fusion-button-text,
                  .fusion-button.button-8:hover i,
                  .fusion-button.button-8:focus .fusion-button-text,
                  .fusion-button.button-8:focus i,
                  .fusion-button.button-8:active .fusion-button-text,
                  .fusion-button.button-8:active {
                    color: #ffffff;
                  }

                  .fusion-button.button-8:hover .fusion-button-icon-divider,
                  .fusion-button.button-8:hover .fusion-button-icon-divider,
                  .fusion-button.button-8:active .fusion-button-icon-divider {
                    border-color: #ffffff;
                  }

                  .fusion-button.button-8:hover,
                  .fusion-button.button-8:focus,
                  .fusion-button.button-8:active {
                    border-color: #ffffff;
                  }

                  .fusion-button.button-8 {
                    border-color: #333333;
                    border-radius: 0px;
                  }

                  .fusion-button.button-8 {
                    background: #fbfbfb;
                  }

                  .fusion-button.button-8:hover,
                  .button-8:focus,
                  .fusion-button.button-8:active {
                    background: #fbfbfb;
                  }
                </style>
                <div class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                  startDateAlert
                }}">
                  <span class="fusion-button-icon-divider button-icon-divider-left" (click)="startDatePicker.open()"><i
                      class="fa-calendar-alt fas" style="color: #c4c4c4 !important"></i></span>
                  <input matInput [matDatepicker]="startDatePicker" placeholder="Data inizio"
                    formControlName="startDate" id="startDate" style="
                    border-bottom: none !important;
                    padding-left: 30px !important;
                    padding-bottom: 3px !important;
                    padding-top: 3px !important;
                  " />
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </div>
                <div [ngStyle]="{
                  visibility:
                    form.get('startDate').valid ||
                    form.get('startDate').pristine
                      ? 'hidden'
                      : 'visible'
                }" class="ng-alert">
                  Scegliere una data di inizio.
                </div>
              </div>
            </div>
          </div>
          <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-12
            fusion-one-half
            fusion-column-last
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          ">
            <div class="fusion-column-wrapper fusion-column-wrapper-12" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-10" style="font-size: 16px; line-height: 27.2px">
                <li class="fusion-li-item">
                  <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                      class="fusion-li-icon fa-calendar-alt fas" style="color: #333333"></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 38.4px">
                    <p>AL*</p>
                  </div>
                </li>
              </ul>
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-9 .fusion-button-text,
                  .fusion-button.button-9 i {
                    color: #c4c4c4;
                  }

                  .fusion-button.button-9 .fusion-button-icon-divider {
                    border-color: #c4c4c4;
                  }

                  .fusion-button.button-9:hover .fusion-button-text,
                  .fusion-button.button-9:hover i,
                  .fusion-button.button-9:focus .fusion-button-text,
                  .fusion-button.button-9:focus i,
                  .fusion-button.button-9:active .fusion-button-text,
                  .fusion-button.button-9:active {
                    color: #fbfbfb;
                  }

                  .fusion-button.button-9:hover .fusion-button-icon-divider,
                  .fusion-button.button-9:hover .fusion-button-icon-divider,
                  .fusion-button.button-9:active .fusion-button-icon-divider {
                    border-color: #fbfbfb;
                  }

                  .fusion-button.button-9:hover,
                  .fusion-button.button-9:focus,
                  .fusion-button.button-9:active {
                    border-color: #fbfbfb;
                  }

                  .fusion-button.button-9 {
                    border-color: #333333;
                    border-radius: 0px;
                  }

                  .fusion-button.button-9 {
                    background: #fbfbfb;
                  }

                  .fusion-button.button-9:hover,
                  .button-9:focus,
                  .fusion-button.button-9:active {
                    background: #fbfbfb;
                  }
                </style>
                <div class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                  endDateAlert
                }}">
                  <span class="fusion-button-icon-divider button-icon-divider-left" (click)="endDatePicker.open()"><i
                      class="fa-calendar-alt fas" style="color: #c4c4c4 !important"></i></span>
                  <input matInput [matDatepicker]="endDatePicker" placeholder="Data fine" formControlName="endDate"
                    id="endDate" style="
                    border-bottom: none !important;
                    padding-left: 30px !important;
                    padding-bottom: 3px !important;
                    padding-top: 3px !important;
                  " />
                  <mat-datepicker #endDatePicker></mat-datepicker>
                </div>
                <div [ngStyle]="{
                  visibility: endDateError === 'no_error' ? 'hidden' : 'visible'
                }" class="ng-alert">
                  {{endDateError}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 30px"></div>
      <p><strong>INFORMAZIONI CONTATTO</strong></p>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>

      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-11
            fusion-one-half
            fusion-column-first
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-1" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa-address-card fas" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>NOME* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-4 .fusion-button-text,
                .fusion-button.button-4 i {
                  color: #333333;
                }

                .fusion-button.button-4 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-4:hover .fusion-button-text,
                .fusion-button.button-4:hover i,
                .fusion-button.button-4:focus .fusion-button-text,
                .fusion-button.button-4:focus i,
                .fusion-button.button-4:active .fusion-button-text,
                .fusion-button.button-4:active {
                  color: #ffffff;
                }

                .fusion-button.button-4:hover .fusion-button-icon-divider,
                .fusion-button.button-4:hover .fusion-button-icon-divider,
                .fusion-button.button-4:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-4:hover,
                .fusion-button.button-4:focus,
                .fusion-button.button-4:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-4 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-4 {
                  background: #ffffff;
                }

                .fusion-button.button-4:hover,
                .button-4:focus,
                .fusion-button.button-4:active {
                  background: #ffffff;
                }
              </style>
              <input type="text" formControlName="contactName" id="contactName" (click)="resetError()" />

            </div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
            <ul class="fusion-checklist fusion-checklist-2" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-envelope" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>EMAIL* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-5 .fusion-button-text,
                .fusion-button.button-5 i {
                  color: #333333;
                }

                .fusion-button.button-5 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-5:hover .fusion-button-text,
                .fusion-button.button-5:hover i,
                .fusion-button.button-5:focus .fusion-button-text,
                .fusion-button.button-5:focus i,
                .fusion-button.button-5:active .fusion-button-text,
                .fusion-button.button-5:active {
                  color: #ffffff;
                }

                .fusion-button.button-5:hover .fusion-button-icon-divider,
                .fusion-button.button-5:hover .fusion-button-icon-divider,
                .fusion-button.button-5:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-5:hover,
                .fusion-button.button-5:focus,
                .fusion-button.button-5:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-5 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-5 {
                  background: #ffffff;
                }

                .fusion-button.button-5:hover,
                .button-5:focus,
                .fusion-button.button-5:active {
                  background: #ffffff;
                }
              </style>
              <input type="email" formControlName="contactEmail" id="contactEmail" (click)="resetError()" />
              <div [ngStyle]="{
                visibility:
                form.get('contactEmail').valid ||
                form.get('contactEmail').pristine
                    ? 'hidden'
                    : 'visible'
              }" class="ng-alert">
                Inserire un'email valida.
              </div>
            </div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-12
            fusion-one-half
            fusion-column-last
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-12" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <ul class="fusion-checklist fusion-checklist-4" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                    class="fusion-li-icon fa fa-phone" style="color: #333333"></i></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>TELEFONO* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-7 .fusion-button-text,
                .fusion-button.button-7 i {
                  color: #333333;
                }

                .fusion-button.button-7 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-7:hover .fusion-button-text,
                .fusion-button.button-7:hover i,
                .fusion-button.button-7:focus .fusion-button-text,
                .fusion-button.button-7:focus i,
                .fusion-button.button-7:active .fusion-button-text,
                .fusion-button.button-7:active {
                  color: #ffffff;
                }

                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-7:hover,
                .fusion-button.button-7:focus,
                .fusion-button.button-7:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-7 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-7 {
                  background: #ffffff;
                }

                .fusion-button.button-7:hover,
                .button-7:focus,
                .fusion-button.button-7:active {
                  background: #ffffff;
                }
              </style>
              <input type="text" formControlName="contactPhone" id="contactPhone" (click)="resetError()" />

            </div>
            <ul class="fusion-checklist fusion-checklist-4" style="font-size: 16px; line-height: 27.2px">
              <li class="fusion-li-item">
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p></p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-7 .fusion-button-text,
                .fusion-button.button-7 i {
                  color: #333333;
                }

                .fusion-button.button-7 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-7:hover .fusion-button-text,
                .fusion-button.button-7:hover i,
                .fusion-button.button-7:focus .fusion-button-text,
                .fusion-button.button-7:focus i,
                .fusion-button.button-7:active .fusion-button-text,
                .fusion-button.button-7:active {
                  color: #ffffff;
                }

                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-7:hover,
                .fusion-button.button-7:focus,
                .fusion-button.button-7:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-7 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-7 {
                  background: #ffffff;
                }

                .fusion-button.button-7:hover,
                .button-7:focus,
                .fusion-button.button-7:active {
                  background: #ffffff;
                }
              </style>
            </div>
          </div>
        </div>
        <div [ngStyle]="{
          visibility: contactError === 'no_error' ? 'hidden' : 'visible'
        }" class="ng-alert">
          {{ contactError }}
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 40px"></div>

      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_3
          fusion-builder-nested-column-25
          fusion-two-third
          fusion-column-first
          2_3
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-25" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <p><strong>COPERTURA PROVINCE</strong></p>
        </div>
      </div>
      <div *ngIf="announcement.announcementStatus === 'DRAFT'" class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-26
          fusion-one-third
          fusion-column-last
          1_3
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4%) * 0.3333));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-26" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-28 {
                border-radius: 0px;
              }
            </style>
            <a (click)="addProvince()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-28
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text">Aggiungi</span></a>
          </div>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="display: flex; flex-wrap: wrap">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_2_3
            fusion-builder-nested-column-25
            fusion-two-third
            fusion-column-first
            2_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 100%;
            width: calc(100%);
            margin-bottom: 29px;
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-13" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <div class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_3
                fusion-builder-nested-column-26
                fusion-one-third
                fusion-column-last
                1_3
              " style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 33.33%;
                width: calc(33.33% - ((4%) * 0.3333));
              "></div>
            <div *ngIf="provinceCodes.length === 0">Tutte le province</div>
            <div *ngIf="provinceCodes.length > 0">
            <div  *ngFor="let provinceItemCode of provinceCodes">
              <div class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 15px"></div>
              <div class="specialization-container">
                <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
                  <div class="
                      fusion-layout-column
                      fusion_builder_column
                      fusion_builder_column_1_2
                      fusion-builder-nested-column-11
                      fusion-one-half
                      fusion-column-first
                      1_2
                    " style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    ">
                    <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      " data-bg-url="">
                      <ul class="fusion-checklist fusion-checklist-15" style="font-size: 16px; line-height: 27.2px">
                        <li class="fusion-li-item">
                          <div class="fusion-li-item-content">Provincia*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-17 .fusion-button-text,
                          .fusion-button.button-17 i {
                            color: #333333;
                          }

                          .fusion-button.button-17 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-17:hover .fusion-button-text,
                          .fusion-button.button-17:hover i,
                          .fusion-button.button-17:focus .fusion-button-text,
                          .fusion-button.button-17:focus i,
                          .fusion-button.button-17:active .fusion-button-text,
                          .fusion-button.button-17:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-17:hover .fusion-button-icon-divider,
                          .fusion-button.button-17:hover .fusion-button-icon-divider,
                          .fusion-button.button-17:active .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-17:hover,
                          .fusion-button.button-17:focus,
                          .fusion-button.button-17:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-17 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-17 {
                            background: #ffffff;
                          }

                          .fusion-button.button-17:hover,
                          .button-17:focus,
                          .fusion-button.button-17:active {
                            background: #ffffff;
                          }
                        </style>
                        <select [(ngModel)]="provinceItemCode.code" [ngModelOptions]="{ standalone: true }"
                          class="manual-validation-valid">
                          <option [ngValue]="null"></option>
                          <option [ngValue]="province.code" *ngFor="let province of provinceList">
                            {{ province.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="announcement.announcementStatus === 'DRAFT'" class="
                      fusion-layout-column
                      fusion_builder_column
                      fusion_builder_column_1_4
                      fusion-builder-nested-column-24
                      fusion-one-fourth
                      fusion-column-last
                      1_4
                    " style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 23%;
                      width: calc(23% - ((4% + 4%) * 0.25));
                    ">
                    <div class="fusion-column-wrapper fusion-column-wrapper-24" style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      " data-bg-url="">
                      <div class="fusion-separator fusion-full-width-sep sep-none" style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 40px;
                        "></div>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-28 {
                            border-radius: 0px;
                          }
                        </style>
                        <a (click)="removeProvince(provinceItemCode.code)" class="
                            fusion-button
                            button-flat
                            fusion-button-default-size
                            button-default button-28
                            fusion-button-span-yes fusion-button-default-type
                          " target="_self"><span class="fusion-button-text">Rimuovi</span></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="fusion-separator fusion-full-width-sep sep-none" style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 15px;
                  "></div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 40px"></div>

      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_3
          fusion-builder-nested-column-25
          fusion-two-third
          fusion-column-first
          2_3
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-25" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <p><strong>ALLEGATI</strong></p>
        </div>
      </div>
      <div *ngIf="announcement.announcementStatus === 'DRAFT'" class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-26
          fusion-one-third
          fusion-column-last
          1_3
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4%) * 0.3333));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-26" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-15 {
                border-radius: 0px;
              }
            </style>
            <input style="display: none" type="file" (change)="uploadAttachment($event)" #uploadInput />
            <a (click)="uploadInputClick()" class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-15
                  fusion-button-span-yes fusion-button-default-type
                " target="_self"><span class="fusion-button-text">Carica Allegato</span></a>
          </div>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="display: flex; flex-wrap: wrap">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_2_3
            fusion-builder-nested-column-25
            fusion-two-third
            fusion-column-first
            2_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 100%;
            width: calc(100%);
            margin-bottom: 29px;
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-13" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <div class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_3
                fusion-builder-nested-column-26
                fusion-one-third
                fusion-column-last
                1_3
              " style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 33.33%;
                width: calc(33.33% - ((4%) * 0.3333));
              "></div>


          </div>
        </div>
      </div>
      <div *ngFor="let attachment of announcement.attachments">
        <div style="margin-bottom: 15px" class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-21
              fusion-three-fourth
              fusion-column-first
              1_2
            " style="
              margin-top: 0;
              margin-bottom: 0;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            ">
            <div class="fusion-column-wrapper fusion-column-wrapper-21" style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <div class="fusion-text" style="font-size: 15px; margin-top: 0px">
                <p style="
                    margin-bottom: 0px !important;
                    color: #333333;
                    font-weight: 400;
                  ">
                  {{ attachment.fileName }}
                  <input type="text" placeholder="Contenuto del file" [ngModelOptions]="{ standalone: true }" [(ngModel)]="attachment.documentType"/>
                </p>
              </div>
            </div>
          </div>
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-22
              fusion-one-fourth
              fusion-column-last
              1_2
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            ">
            <div style=" position: absolute; top: 30px;" class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div *ngIf="announcement.announcementStatus === 'DRAFT'" class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-21
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((1%) * 0.5));
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                      margin-right: 4%;
                  " data-bg-url="">
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a (click)="deleteAttachment(attachment)" class="
                        fusion-button
                        button-flat
                        fusion-button-default-size
                        button-default
                        fusion-button-default-span fusion-button-default-type
                      " target="_self"><span class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "><i class="fa-trash-alt fas"></i></span><span
                        class="fusion-button-text fusion-button-text-left">RIMUOVI</span></a>
                  </div>
                </div>
              </div>
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-22
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((1%) * 0.5));
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                    margin-left: 4%;
                  " data-bg-url="">
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a (click)="openAttachment(attachment, null)" class=" fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-default-span 
                    fusion-button-default-type" target="_self"><span class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "><i class="fa-save fas"></i></span><span
                        class="fusion-button-text fusion-button-text-left">SCARICA</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"></div>

      <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_2_3
        fusion-builder-nested-column-25
        fusion-two-third
        fusion-column-first
        2_3
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 66.66%;
        width: calc(66.66% - ((4%) * 0.6666));
        margin-right: 4%;
      ">
        <div class="fusion-column-wrapper fusion-column-wrapper-25" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
          <p><strong>OFFERTE</strong></p>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div *ngIf="!announcement.announcementOffers || announcement.announcementOffers.length === 0"
        style="margin-bottom: 15px" class="fusion-builder-row fusion-builder-row-inner fusion-row">
        Non è ancora arrivata nessuna offerta
      </div>
      <div *ngFor="let offer of announcement.announcementOffers">
        <div style="margin-bottom: 15px" class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-21
              fusion-three-fourth
              fusion-column-first
              1_2
            " style="
              margin-top: 0;
              margin-bottom: 0;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            ">
            <div class="fusion-column-wrapper fusion-column-wrapper-21" style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <div class="fusion-text" style="font-size: 15px; margin-top: 0px">
                
                  <b>Offerente:</b> {{ offer.bidderName }}<br />
                  <b>Q.tà richiesta:</b> {{ offer.amount | currency: "EUR":"":"0.2-2":"it-IT" }} {{
                  offer.unitOfMeasureName }}<br />
                  <b>Offerta per unità:</b> {{ offer.unitPrice | currency: "EUR":"":"0.2-2":"it-IT" }} €<br />
                  <div *ngIf="announcement.announcementType === 'RENTAL'">
                    <b>Periodo richiesto:</b> {{ offer.startDate | date:'dd/MM/yyyy' }} - {{ offer.endDate | date:'dd/MM/yyyy' }}<br />
                    <b>Durata richiesta:</b> {{offer.timeUnitAmount}} {{offer.timeUnitType}}<br/>
                  </div>
              </div>
            </div>
          </div>
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-22
              fusion-one-fourth
              fusion-column-last
              1_2
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            ">
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-22
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((1%) * 0.5));
                ">
                <div
                  *ngIf="announcement.announcementStatus === 'PUBLISHED' && offer.announcementOfferStatus === 'SUBMITTED'"
                  class="fusion-column-wrapper fusion-column-wrapper-22" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                    margin-left: 4%;
                    display:inline-flex;
                  " data-bg-url="">
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a (click)="acceptOffer(offer)" class=" fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-default-span 
                    fusion-button-default-type" target="_self"><span class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "><i class="fa-check fas"></i></span><span
                        class="fusion-button-text fusion-button-text-left">ACCETTA</span></a>
                  </div>
                  <div class="fusion-button-wrapper fusion-align-block" style="margin-left: 20px">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a (click)="refuseOffer(offer)" class=" fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-default-span 
                    fusion-button-default-type" target="_self"><span class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "><i class="fa-times fas"></i></span><span
                        class="fusion-button-text fusion-button-text-left">RIFIUTA</span></a>
                  </div>
                </div>
                <div
                  *ngIf="announcement.announcementStatus !== 'PUBLISHED' || offer.announcementOfferStatus !== 'SUBMITTED'"
                  class="fusion-column-wrapper fusion-column-wrapper-22" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                    margin-left: 4%;
                    display:inline-flex;
                  " data-bg-url="">
                  <div class="fusion-button-wrapper fusion-align-block">
                    <b> {{ getAnnouncementOfferStatusDescr(offer) }} </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-modal #refusalModal>
          <ng-template #header>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
            <div class="fusion-text">
              <h3 style="text-align: center">MOTIVO DEL RIFIUTO </h3>
            </div>
          </ng-template>
          <ng-template #body>
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <textarea type="text" style="height: 200px" [(ngModel)]="offer.refusalNotes"
                [ngModelOptions]="{standalone: true}" maxlength="1500"></textarea>
            </div>
          </ng-template>
          <ng-template #footer>
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-21
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 100%;
                ">
              </div>
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-22
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 100%;
                  width: calc(100% - ((1%) * 0.5));
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a (click)="refuseOfferWithNotes()" style="width: 100%;" class=" fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-default-span 
                    fusion-button-default-type" target="_self"><span
                        class="fusion-button-text fusion-button-text-left">CONFERMA</span></a>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </app-modal>
      </div>
      <div *ngIf="announcement.announcementStatus === 'DRAFT'"
        class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-34
            fusion-one-half
            fusion-column-first
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-34" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            " data-bg-url="">
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-18 {
                  border-radius: 0px;
                }
              </style>
              <a (click)="saveAnnouncement()" #saveButton class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                " target="_self"><span class="fusion-button-text">SALVA</span></a>
            </div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-35
            fusion-one-half
            fusion-column-last
            1_2
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          ">
          <div class="fusion-column-wrapper fusion-column-wrapper-35" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            " data-bg-url="">
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-19 {
                  border-radius: 0px;
                }
              </style>
              <a (click)="submitAnnouncement()" class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                " target="_self"><span class="fusion-button-text">PUBBLICA</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none ng-space"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"></div>
      <div *ngIf="!showSaveMessage" [ngStyle]="{ visibility: error === 'no_error' ? 'hidden' : 'visible' }"
        class="ng-alert">
        {{ error }}
      </div>
      <div *ngIf="showSaveMessage" class="ng-info">
        {{ saveMessage }}
      </div>
      <div class="ng-spinner">
        <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg" />
      </div>
      <div class="fusion-text" style="font-size: 17px; font-style: italic"
        *ngIf="announcement.announcementStatus === 'APPROVAL'">
        L'annuncio è stato inviato a Skimming e verrà pubblicato nel più breve tempo possibile.
      </div>
    </form>
  </div>